import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card, Col, Row, Typography, Image, Dropdown, Divider, Skeleton, Drawer } from "antd";
import { CloseOutlined, FilterOutlined, PlusOutlined, DownOutlined } from "@ant-design/icons";

import ArtWorkModel from "../add/model";
import { listArtwork } from "../../../api/artwork";
import { FilterFieldsRender } from "../../filter/component";
import Meta from "antd/es/card/Meta";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { DeletePopupModal } from "../../elements/delete-popup-model/components";
import './style.scss';
import { ENVIRONMENT } from "../../../common/constants";

const ArtWorkList = (props: any) => {
    const { userId } = props;
    const { Text } = Typography;
    const [artlists, setArtlists] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [open, setOpen] = useState(false);
    const [deleteModelOpen, setDeleteModelOpen] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
    const [filterValues, setFilterValues] = useState<object[]>([]);
    const [versions, setVersion] = useState({ id: '', title: '' });
    const [isMobile, setIsMobile] = useState(false);
    const [actionsDropdownOpen, setActionsDropdownOpen] = useState(false);

    const navigate = useNavigate();
    const cardNavigation = (key: any) => {
        if (key === "edit") {
            return;
        } else {
            navigate(`/artwork/${key?.id}`, { state: key });
        }
    };

    useEffect(() => {
        fetchArtLists();
    }, [filterValues]);

    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth <= 480;
            console.log('Mobile check:', mobile, 'Window width:', window.innerWidth);
            setIsMobile(mobile);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Temporary: Force mobile view for testing (remove this later)
    // setIsMobile(true);

    const fetchArtLists = async () => {
        setLoading(true);
        try {
            const postData = {
                filter: filterValues ? filterValues : [],
                userId: userId
            };

            const { data, status } = await listArtwork(postData);
            if (status === 'Success') {
                setArtlists(data);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const filterContent = (
        <div 
            className="filter-content-wrapper" 
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        >
            <Row justify="space-between" align="middle" className="filter-header">
                <h3 style={{ color: "#191c55", fontWeight: "bold" }} className="filter-title">
                    <FilterOutlined /> <span style={{ letterSpacing: "0.5px", color: '#191c55' }}>Filters</span>
                </h3>
                <CloseOutlined
                    style={{ cursor: "pointer", color: "#191c55", fontSize: "16px" }}
                    className="filter-close-btn"
                    onClick={() => {
                        setFilterDropdownOpen(false);
                        // setFilterValues([]);
                    }}
                />
            </Row>
            <Divider style={{ margin: "8px 0 16px 0" }} />
            <div
                className="filter-fields-container"
                style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                    overflowX: 'hidden'
                }}
            >
                {FilterFieldsRender([
                    "Inventory No",
                    "Title",
                    "Artist Name",
                ],
                    setFilterValues,
                    filterValues,
                    setFilterDropdownOpen,
                    'ArtWork'
                )}
            </div>
        </div>
    );

    return (
        <div>
            <Card
                title={<Row style={{ gap: 10 }}>
                    <p style={{ fontSize: 22, marginLeft: '10px' }}>Artworks</p>
                </Row>}
                style={{ height: '90vh', borderTop: 'none' }}
                styles={{
                    header: { border: 'none', },
                    title: {
                        fontSize: '24px',
                        lineHeight: '36px',
                        fontWeight: 700,
                        color: '#171A1FFF',
                    },
                }}
                className="art-card-container"
                extra={
                    <div className="artwork-header-actions">
                        {isMobile ? (
                            <Dropdown
                                menu={{
                                    items: [
                                        {
                                            key: 'filter',
                                            icon: <FilterOutlined />,
                                            label: 'Filter',
                                            className: 'filter-dropdown-item',
                                            onClick: () => {
                                                console.log('Filter clicked, setting filterDropdownOpen to true');
                                                setActionsDropdownOpen(false);
                                                setTimeout(() => {
                                                    setFilterDropdownOpen(true);
                                                }, 100);
                                            }
                                        },
                                        {
                                            key: 'upload',
                                            icon: <PlusOutlined />,
                                            label: 'Upload Artwork',
                                            className: 'upload-dropdown-item',
                                            onClick: () => {
                                                console.log('Upload clicked');
                                                setActionsDropdownOpen(false);
                                                setOpen(true);
                                            }
                                        }
                                    ]
                                }}
                                trigger={['click']}
                                placement="bottomRight"
                                open={actionsDropdownOpen}
                                onOpenChange={(open) => {
                                    console.log('Actions dropdown onOpenChange:', open);
                                    setActionsDropdownOpen(open);
                                }}
                                getPopupContainer={(trigger) => trigger?.parentElement ?? document.body}
                                className="actions-dropdown"
                            >
                                <Button
                                    className="action-btn menu-btn"
                                    onClick={() => {
                                        console.log('Actions button clicked, current state:', actionsDropdownOpen);
                                        setActionsDropdownOpen(!actionsDropdownOpen);
                                    }}
                                >
                                    Actions <DownOutlined />
                                </Button>
                            </Dropdown>
                        ) : (
                            <>
                                <Dropdown
                                    rootClassName="filter-dropdown-list"
                                    dropdownRender={() => filterContent}
                                    overlayStyle={{ padding: 0 }}
                                    placement="bottomRight"
                                    trigger={['click']}
                                    open={filterDropdownOpen}
                                    onOpenChange={(open) => {
                                        // Only allow opening, closing is handled by close icon
                                        if (open) {
                                            setFilterDropdownOpen(true);
                                        }
                                    }}
                                    getPopupContainer={(trigger: any) => trigger?.parentElement ?? document?.body}
                                >
                                    <Button
                                        icon={<FilterOutlined />}
                                        className="filter-btn menu-btn"
                                    >
                                        Filter
                                    </Button>
                                </Dropdown>
                                <Button
                                    icon={<PlusOutlined style={{ color: "rgb(255, 255, 255)" }} />}
                                    onClick={() => setOpen(true)}
                                    className="upload-btn menu-btn"
                                >
                                    Upload Artwork
                                </Button>
                            </>
                        )}
                    </div>
                }
            >

                {loading ? <Skeleton.Button
                    style={{ height: "70vh", marginTop: "1.4%" }}
                    active={true}
                    size={'small'}
                    shape={"square"}
                    block={true}
                /> :
                    <>
                        {artlists?.length ? <div>
                            <Row gutter={[20, 20]}>
                                {artlists?.map((arts, index) => {
                                    return <Col xxl={4} xl={6} key={index} >
                                        <Card
                                            variant="borderless"
                                            hoverable
                                            style={{ borderRadius: 10 }}
                                            styles={{ body: { padding: 5 } }}
                                            cover={<Fragment>
                                                {arts?.ArtworkMedia?.map((artimage: any, i: any) => {
                                                    return artimage?.version === "Initial version" && <Fragment key={i}>
                                                        <Image
                                                            onClick={() => cardNavigation(arts)}
                                                            width={'100%'}
                                                            loading="lazy"
                                                            preview={false}
                                                            style={{ borderRadius: 10 }}
                                                            height={200}
                                                            src={`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/resizedImages/${artimage?.fileS3Path}`} />
                                                    </Fragment>;
                                                })}
                                            </Fragment>}
                                        >
                                            <Meta style={{ padding: 5 }}
                                                title={<Text ellipsis style={{ padding: '0px 5px', fontSize: 16 }} onClick={() => cardNavigation(arts)}>{arts?.title}</Text>}
                                                description={<Row style={{ padding: '0px 5px', paddingBottom: 10 }} justify={'space-between'}>
                                                    <Col xs={20} sm={21} onClick={() => cardNavigation(arts)}>
                                                        <>Artitst by</>
                                                        <Text ellipsis style={{ color: 'black', paddingLeft: 5, width: '60%' }}>{arts.artistName}</Text>
                                                    </Col>
                                                    <Col xs={4} sm={3}>
                                                        <Dropdown
                                                            trigger={['click']}
                                                            menu={{
                                                                items: [{
                                                                    key: "1",
                                                                    label: 'Delete',
                                                                    onClick: () => {
                                                                        setDeleteModelOpen(true);
                                                                        setVersion({ id: arts.id, title: arts.title });
                                                                    }
                                                                }]
                                                            }}
                                                        >
                                                            <HiOutlineDotsHorizontal style={{ fontSize: 20 }} />
                                                        </Dropdown>
                                                    </Col>
                                                </Row>} />
                                        </Card>
                                    </Col>;
                                })}
                            </Row>
                        </div> : <>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                                <Card variant="borderless" className="no-artwork-card">
                                    <Row gutter={32} justify="center" align="middle">
                                        <Col span={24}>
                                            <Text type="secondary" style={{
                                                fontSize: '24px',
                                                lineHeight: '36px',
                                                fontWeight: 700,
                                                color: '#171A1FFF'
                                            }}>
                                                No Artworks Found
                                            </Text>
                                        </Col>
                                        <Col span={24}>
                                            <Button
                                                icon={<PlusOutlined />}
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    background: '#636AE8FF',
                                                    borderRadius: '6px',
                                                    color: '#FFFFFFFF',
                                                    padding: '10px 20px',
                                                    marginTop: 10
                                                }}
                                                onClick={() => setOpen(true)}
                                            >Upload Artwork</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                        </>}
                        <ArtWorkModel render={fetchArtLists} userId={userId} open={open} setOpen={setOpen} />
                        <DeletePopupModal
                            userId={userId}
                            render={fetchArtLists}
                            id={versions?.id}
                            title={versions?.title}
                            open={deleteModelOpen}
                            setOpen={setDeleteModelOpen}
                            deleteBtnLoading={deleteBtnLoading}
                            setDeleteBtnLoading={setDeleteBtnLoading}
                            type={'ArtWorkList'}
                        />
                    </>}
            </Card >



            {/* Mobile Filter Drawer */}
            {isMobile && (
                <Drawer
                    title={null}
                    placement="right"
                    onClose={() => setFilterDropdownOpen(false)}
                    open={filterDropdownOpen}
                    width="85%"
                    className="filter-drawer"
                    bodyStyle={{ padding: 0 }}
                >
                    {filterContent}
                </Drawer>
            )}
        </div>

    );
};
export default ArtWorkList;